// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"vWCCoH","card":"_3SNp46","cardHeading":"yfhqjX","cardTitle":"_3hM_pq","titleChronicle":"_12n19b","cardSubtitle":"_3OuN7r","iframeBox":"_2ZY60r"};